import React from 'react';
import { Icon } from '../../components';
import './OnboardingPitch.css';

/**
 * Desktop-only left column for the onboarding screen. Hidden on
 * viewports below 900px via CSS (display: none under the breakpoint).
 *
 * Content is purely descriptive — no interaction. The big "Drop into
 * the conversation." heading is the desktop H1 (the right card carries
 * its own smaller "Let's get you a name" subhead instead of an H1 on
 * desktop, to preserve heading hierarchy).
 */
const OnboardingPitch = () => (
  <section className="onboard-pitch" aria-labelledby="onboard-pitch-heading">
    <span className="onboard-pitch__badge">
      <Icon name="sparkle" size={12} />
      No signup &middot; no email
    </span>
    <h1 id="onboard-pitch-heading" className="onboard-pitch__heading">
      Drop into the
      <br />
      conversation.
    </h1>
    <ul className="onboard-pitch__features" aria-label="Glacier features">
      <li>
        <Icon name="globe" size={14} />
        <span>Global room</span>
      </li>
      <li>
        <Icon name="party" size={14} />
        <span>4-letter parties</span>
      </li>
      <li>
        <Icon name="users" size={14} />
        <span>Ephemeral &middot; 24h</span>
      </li>
    </ul>
  </section>
);

export default OnboardingPitch;
